import {CommonModule} from '@angular/common';
import {AppNumberPipe} from '@frontend/shared';
import {Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {TableModule} from 'primeng/table';
import {ImportanceIconComponent} from '../importance-icon/importance-icon.component';
import {ProviderColumn} from '../table/provider-results-table/provider-results-table.types';
import {SubcriteriaAttributeScoreData} from './subcriteria-attribute-scores.types';

@Component({
  selector: 'app-subcriteria-attribute-scores-table',
  imports: [AppNumberPipe, CommonModule, TranslocoPipe, TableModule, ImportanceIconComponent],
  templateUrl: './subcriteria-attribute-scores-table.component.html',
  styleUrls: ['./subcriteria-attribute-scores-table.component.scss'],
})
export class SubcriteriaAttributeScoresTableComponent {
  readonly rows = input.required<SubcriteriaAttributeScoreData[]>();
  readonly providers = input.required<ProviderColumn[]>();
  readonly hideImportanceColumn = input(false);
}
